import { Contact } from 'apps/wrapper/src/services/api-client/contact-api';
import { AppointmentModificationDetails } from 'apps/wrapper/src/services/appointment/types/appointment-modifications';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import { createContext } from 'react';

export interface RescheduleRequestViewContextProps {
  isLoading: boolean;
  contact: Contact | undefined;
  isEditable: boolean;
  requestDetails: AppointmentRequestDetails;
  originalAppointment: AppointmentModificationDetails | undefined;
  tempAppointment: AppointmentModificationDetails | undefined;
}

export const RescheduleRequestViewContext = createContext<RescheduleRequestViewContextProps>(null!);
